module.exports = "/images/il.svg?972298f9109fc298a3332190498dff74";